// extracted by mini-css-extract-plugin
var _1 = "ImageCaption-module__animatedBackground--G_0UZ";
var _2 = "ImageCaption-module__caption--AczKE";
var _3 = "ImageCaption-module__captionContainer--xZzHq";
var _4 = "ImageCaption-module__empty--rVT7N";
var _5 = "ImageCaption-module__hide--oTVsp";
export { _1 as "animatedBackground", _2 as "caption", _3 as "captionContainer", _4 as "empty", _5 as "hide" }
